import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {crmRoutesPath} from './path';

const CrmPage = Loadable(
  lazy(() =>
    import('../../v2/pages/Crm/Crm.page').then(module => ({
      default: module.CrmPage,
    })),
  ),
);

export const crmRoutes = [
  {
    element: <CrmPage />,
    path: crmRoutesPath.$path(),
  },
] satisfies RouteConfig[];
